import { HttpClient } from '@angular/common/http';
import { TranslocoLoader } from '@jsverse/transloco';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  constructor() {}

  getTranslation(lang: string): Observable<any> {
    console.log('Loading translation for language:', lang);
    return this.http.get(`./assets/i18n/${lang}.json`).pipe(
      catchError((error) => {
        console.error('Error loading translation for', lang, error);
        // Fallback to English if the requested language fails to load
        if (lang !== 'en') {
          return this.http.get(`./assets/i18n/en.json`);
        }
        return of({});
      }),
    );
  }
}
